
import {toggleDisplay} from './Util';

class ImageErrorHandler {

	constructor( imageEl ) {
		imageEl.addEventListener( 'error', ( evt ) => toggleDisplay( evt.target, false ) );
	}
}

const initImageErrorHandler = ( scopeEl = document ) => {
	const imageEls = Array.from( scopeEl.querySelectorAll( 'img.en_js_hide_onerror' ) );
	imageEls.forEach( imageEl => {
		imageEl.SL_ImageErrorHandler ??= new ImageErrorHandler( imageEl );
	} );
}

export {
	ImageErrorHandler as default,
	initImageErrorHandler
}
